// extracted by mini-css-extract-plugin
export default {"link":"PatientForm_link__SaW1V"};